import React, { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player/lazy";
import { useTranslation } from "react-i18next";
import * as a from "../../../../constants/api";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import GamesTable from "../../../../components/Lists/GraphicsAdmin/GamesTableSmart";
import TableSmart from "../../../../components/Lists/GraphicsAdmin/TestTableSmart";
import BarGraphic from "../../../../components/Lists/GraphicsAdmin/BarGraphics";
import RadarGraphic from "../../../../components/Lists/GraphicsAdmin/RadarGraphic";
import SessionContext from "../../../../context/sessionContext";
import Spinner from "../../../../components/Spinner";
import useFetch from "../../../../hooks/useFetch";
import pClasses from "./Users.module.scss";
import ClientsPdf from "../../../../components/Lists/GeneratePdf/index";
import RoundButton from "../../../../components/Buttons/RoundButton";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { getLastProperty } from "../../../../helpers";

export default function TabUserReports(props?: any) {
  const cSession = useContext(SessionContext);
  const { t } = useTranslation();
  const { user } = cSession ?? {};

  // Estado local usado como fallback (reserva) caso não venha pela props
  const [choosedShotFallback, setChoosedShotFallback] = useState();

  // Se o componente recebeu props preenchidas, usa elas
  // Senão, usa o estado local (fallback) para evitar undefined
  const { setChoosedShot, choosedShot } =
    Object.keys(props).length > 0
      ? props
      : {
          setChoosedShot: setChoosedShotFallback,
          choosedShot: choosedShotFallback,
        };

  const [userInfos, , , fetchUserInfos]: any = useFetch({
    autoInit: false,
  });
  const [gamesInfo, isloadingGames, gamesError, fetchUserGamesInfo]: any =
    useFetch({
      autoInit: false,
    });

  useEffect(() => {
    if (gamesInfo === null && user?.token)
      fetchUserGamesInfo({
        noAuth: true,
        url: a.API_USER_GAMES,
        header: {
          userauthorization: user.token,
        },
      });
  }, [user?.token]);

  const [toggleState, setToggleState] = useState(4);
  const [isEndJourneyFirstTime, setIsEndJourneyFirstTime] = useState<any>(null);
  const [open, setOpen] = useState(true);
  const [openVideo, setOpenVideo] = useState(true);
  const [_content, setContent] = useState(<Spinner center />);

  const toggleTab = (index: any) => {
    setToggleState(index);
  };

  // Dados básicos com verificações mínimas necessárias
  const DataTests = userInfos;
  const NameUser = cSession?.user?.registry;
  const lastIndex = userInfos ? getLastProperty(userInfos) : null;

  // Verificação mais permissiva para HasReavaliation
  // Permite choosedShot como 0, string "0", etc - apenas bloqueia undefined/null
  const getJourneyCode = () => {
    if (!userInfos) return null;

    // Se choosedShot não está definido, usar a primeira chave disponível ou padrão
    const shotKey =
      choosedShot !== undefined
        ? choosedShot
        : Object.keys(userInfos)[0] || "1";
    const userInfo = userInfos[shotKey];

    return userInfo?.journey_code ?? null;
  };

  const journeyCode = getJourneyCode();
  const HasReavaliation = journeyCode === 3;

  // Verificação de data com fallback seguro
  const getFormattedDate = () => {
    try {
      if (DataTests?.[1]?.date_IA_finish) {
        const dataIaFinish = new Date(DataTests[1].date_IA_finish);
        return dataIaFinish.toLocaleDateString("pt-BR");
      }
    } catch (error) {
      console.warn("Erro ao formatar data:", error);
    }
    return new Date().toLocaleDateString("pt-BR");
  };

  const dataIaFinishFormated = getFormattedDate();

  const [fetchedJourneys, , , journeyFetch]: any = useFetch({
    autoInit: false,
  });

  useEffect(() => {
    if (user?.token) {
      journeyFetch({
        noAuth: true,
        url: a.API_USER_STATISTICS,
        header: {
          userauthorization: user.token,
        },
      });
    }
  }, [user?.token]);

  useEffect(() => {
    const relat = new URL(window.location.href);
    let caixa = [] as Array<any>;
    caixa = relat.pathname.split("/").reverse();

    if (user?.token && !fetchedJourneys) {
      fetchUserInfos({
        noAuth: true,
        url: a.API_USER_STATISTICS,
        header: {
          userauthorization: user.token,
        },
      });
    }
  }, [toggleState, choosedShot, user?.token]);

  // UseEffect para renderizar conteúdo - mantém a lógica original mas com proteções mínimas
  useEffect(() => {
    // Determina o shot atual, usando fallback se necessário
    const currentShot =
      choosedShot !== undefined
        ? choosedShot
        : userInfos
        ? Object.keys(userInfos)[0]
        : null;

    if (toggleState === 1) {
      setContent(
        <TableSmart
          fetchedJourney={fetchedJourneys?.[currentShot]}
          users={userInfos}
          showUser
          showActiveStatus
          showAccess_code
          showBirthdate
        />
      );
    } else if (toggleState === 2) {
      setContent(
        <RadarGraphic fetchedJourney={fetchedJourneys?.[currentShot]} />
      );
    } else if (toggleState === 3) {
      setContent(
        <GamesTable
          users={userInfos}
          gamesInfo={gamesInfo}
          showUser
          showActiveStatus
          showAccess_code
          showBirthdate
          choosedShot={currentShot}
        />
      );
    } else if (toggleState === 4) {
      setContent(
        <BarGraphic fetchedJourney={fetchedJourneys?.[currentShot]} />
      );
    }
  }, [toggleState, choosedShot, fetchedJourneys, gamesInfo, userInfos]);

  // Inicialização do localStorage
  useEffect(() => {
    if (!localStorage.getItem("end_journey")) {
      localStorage.setItem("end_journey", "true");
    }
    if (isEndJourneyFirstTime === null) {
      setIsEndJourneyFirstTime(localStorage.getItem("end_journey"));
    }
  }, [isEndJourneyFirstTime]);

  /** NOME DO USUÁRIO */
  const relat = new URL(window.location.href);
  let caixa = [] as Array<any>;
  caixa = relat.pathname.split("/").reverse();
  const selectedJourney = choosedShot;

  const btnPdfDownload = (
    <RoundButton
      small
      className={pClasses.BtnPdf}
      text={t("global.print_final_report")}
      faIcon={faFilePdf}
      title={t("global.print_final_report")}
      onClick={() => {
        if (HasReavaliation) {
          ClientsPdf({
            DataTests,
            NameUser,
            selectedJourney,
            t,
          });
        } else {
          setOpen(false);
        }
      }}
    />
  );

  const modalDialog = (
    <Dialog
      open={!open}
      onClose={() => setOpen(true)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("global.print_report")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("global.print_info") + dataIaFinishFormated}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(true)} autoFocus>
          {t("global.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Verificação para modal de vídeo - mantém a lógica original com proteção
  const shouldShowVideoModal = () => {
    if (!userInfos) return false;

    try {
      const keys = Object.keys(userInfos);
      if (keys.length === 0) return false;

      const lastKey = keys[keys.length - 1];
      const lastUserInfo = userInfos[lastKey];

      return lastUserInfo?.journey_code === 3;
    } catch (error) {
      console.warn("Erro ao verificar modal de vídeo:", error);
      return false;
    }
  };

  const videoModal = (
    <Dialog
      open={
        (!openVideo || isEndJourneyFirstTime === "true") &&
        shouldShowVideoModal()
      }
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("global.end_journey_congrats")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <ReactPlayer
            id="video"
            width="100%"
            controls
            playing
            light="img/main-page/image.webp"
            playIcon={
              <div>
                <RoundButton
                  key={"audioFile"}
                  center
                  className={pClasses.BtnPlayVideo}
                  disabled={false}
                  faIcon={faPlay}
                  huge
                  onClick={() => () => {
                    localStorage.setItem("end_journey", "false");
                    setIsEndJourneyFirstTime("false");
                  }}
                  title={t("global.play_audio_test")}
                />
              </div>
            }
            url="https://player.vimeo.com/video/851433022?badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479"
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpenVideo(true);
            setIsEndJourneyFirstTime("false");
            localStorage.setItem("end_journey", "false");
          }}
          autoFocus
        >
          {t("global.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  const btnOptions = (
    <div className={pClasses.TabUser}>
      <button
        className={`${toggleState === 1 ? pClasses.activetabs : pClasses.tabs}`}
        onClick={() => toggleTab(1)}
      >
        RESULTADO TESTES
      </button>
      <button
        className={`${toggleState === 4 ? pClasses.activetabs : pClasses.tabs}`}
        onClick={() => toggleTab(4)}
      >
        GRÁFICO BARRAS
      </button>
      {/* <button
        className={`${toggleState === 2 ? pClasses.activetabs : pClasses.tabs}`}
        onClick={() => toggleTab(2)}
      >
        GRÁFICO RADAR
      </button> */}
      <button
        className={`${toggleState === 3 ? pClasses.activetabs : pClasses.tabs}`}
        onClick={() => toggleTab(3)}
      >
        JOGOS
      </button>
    </div>
  );

  // Função setJourney mais permissiva
  const setJourney = (j: any) => {
    // Remove a verificação restritiva - permite que a função seja chamada
    if (typeof setChoosedShot === "function") {
      setChoosedShot(String(j));
    }
  };

  // Pega todas as jornadas do usuário (as chaves do objeto userInfos)
  const chooseJourney = userInfos ? Object.keys(userInfos) : [];

  // Array onde vamos guardar os <option> do select
  const optionsJourney: any[] = [];

  // Cria um array auxiliar do mesmo tamanho que a quantidade de jornadas
  const numberOfJourneys =
    chooseJourney.length > 0
      ? new Array<number>(chooseJourney.length).fill(1)
      : [];

  // Para cada jornada encontrada, cria uma <option> e adiciona em optionsJourney
  numberOfJourneys.forEach((journey: any, index: any) => {
    const opt = (
      <option key={index} value={index}>
        {t("global.journey")} {index + 1}
      </option>
    );
    optionsJourney.push(opt);
  });

  // Sempre que userInfos mudar, seta automaticamente a última jornada como selecionada no select
  useEffect(() => {
    // Verifica se userInfos está definido e não é undefined
    if (userInfos && Object.keys(userInfos).length > 0) {
      // Pega todas as chaves (jornadas) do objeto userInfos
      const keys = Object.keys(userInfos);

      // Seleciona a última chave (última jornada)
      const lastKey = keys[keys.length - 1];

      // Atualiza o estado para definir essa última jornada como selecionada
      setJourney(lastKey);
    }
  }, [userInfos]); // Executa esse efeito toda vez que userInfos mudar

  // Renderiza o select de jornadas (se houver opções disponíveis)
  const selectJourney =
    optionsJourney.length > 0 ? (
      <div className={pClasses.SelectJourneyArea}>
        {t("global.selec_other_journey")}:{"  "}
        <select
          // Quando o usuário muda a opção selecionada, atualiza a jornada escolhida
          onChange={(e) => setJourney(String(Number(e.target.value) + 1))}
          className={pClasses.SelectJourney}
          // Define qual opção está selecionada no momento (value controlado)
          value={choosedShot ? String(Number(choosedShot) - 1) : "0"}
        >
          {optionsJourney}
        </select>
      </div>
    ) : null; // Se não tiver opções, não renderiza nada (null)

  return (
    <>
      <div className={pClasses.contentUserEndJourney}>
        {selectJourney}
        {btnOptions}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {btnPdfDownload}
        </div>
        {modalDialog}
        {videoModal}
        <div>{_content}</div>
        {shouldShowVideoModal() && (
          <div>
            <RoundButton
              title={t("global.video")}
              text={t("global.video")}
              small
              className={pClasses.videoBtn}
              onClick={() => {
                setOpenVideo(!openVideo);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
}
